import { Delete, Edit } from "react-iconly";
import React from "react";
import "react-responsive-modal/styles.css";
import "react-bootstrap-table/css/react-bootstrap-table.css";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { NavLink } from "react-router-dom";
import ChampsSkeleton from "../ChampsSkeleton";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import LoginFormData from "../../../../repositories/user/LoginFormData";
import { fetchLocations } from "../../../../redux/Location/LocationAction";
import Location from "../../../../services/Location";
import ModalLocation from "../LesModals/ModalLocation";

const Champstable = () => {
  const [isPageLoading, setIsPageLoading] = React.useState(true);
  const [typeForm, setTypeForm] = React.useState("");
  const [locationDatas, setLocationDatas] = React.useState([]);
  const dispatch = useDispatch();

  const locations = useSelector((state: RootStateOrAny) => state.locations);
  const token = window.localStorage.getItem("userToken");

  React.useEffect(() => {
    setTimeout(() => {
      setIsPageLoading(false);
    }, 3000);
  }, []);

  const getLocationData = (data: any) => {
    setTypeForm("update");
    setLocationDatas(data);
  };
  const actionFormatter = (cell, row) => {
    return (
      <div className="parametre-actions-container">
        <NavLink
          to="#"
          style={{
            color: "linear-gradient(180deg, #06640C 0%, #061A07 100%)",
          }}
          onClick={() => getLocationData(row)}
          data-toggle="modal"
          data-target="#updateLocationModal"
          title="Edit this location"
        >
          <Edit
            set="bold"
            primaryColor="linear-gradient(180deg, #06640C 0%, #061A07 100%)"
            style={{
              fontSize: "20px",
            }}
          />
        </NavLink>

        <NavLink
          to="#"
          style={{
            color: "#E53E3E",
          }}
          onClick={() => onDeleteLocation(row?.id)}
          title="Delete this location"
        >
          <Delete
            set="bold"
            primaryColor="#E53E3E"
            style={{
              fontSize: "16px",
              width: "20px",
              marginLeft: " 10px",
            }}
          />
        </NavLink>
      </div>
    );
  };

  const onDeleteLocation = (id: LoginFormData) => {
    Swal.fire({
      title: "Do you want to delete this location ?",
      // showDenyButton: true,
      confirmButtonText: `YES`,
      cancelButtonText: `NO`,
      iconColor: "#df5656",
      showCancelButton: true,
      confirmButtonColor: "#df5656",
      cancelButtonColor: "#6c757d",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const addRequest = Location.onDeleteLocation(id, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        addRequest
          .then((response) => {
            dispatch(fetchLocations());
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Location deleted successfully",
              showConfirmButton: true,
              iconColor: "#df5656",
              confirmButtonColor: "#df5656",
              allowOutsideClick: false,
            });
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Oops! An error occurred while deleting",
              showConfirmButton: true,
              iconColor: "#df5656",
              confirmButtonColor: "#df5656",
              allowOutsideClick: false,
            });
          });
      } else {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Deletion was successfully undone",
          showConfirmButton: true,
          iconColor: "#df5656",
          confirmButtonColor: "#df5656",
          allowOutsideClick: false,
        });
      }
    });
  };

  return (
    <div className="infos-perso-input">
      <>
        {locations?.isLoading && <ChampsSkeleton />}
        {!locations?.isLoading && (
          <BootstrapTable
            data={locations.data && locations.data}
            striped={true}
            hover={true}
            condensed={false}
            multiColumnSort={2}
            search={false}
            version="4"
            bordered={false}
            pagination
          >
            <TableHeaderColumn
              width="50"
              dataField="id"
              isKey={true}
              bordered={false}
              thStyle={{
                fontWeight: 600,
                fontSize: 14,
                color: "#BABEC6",
              }}
              tdStyle={{
                fontWeight: 500,
                fontSize: 16,
                color: "rgba(0, 0, 0, 0.8)",
                padding: 20,
              }}
              hidden
            >
              N°
            </TableHeaderColumn>

            <TableHeaderColumn
              dataField="name"
              bordered={false}
              thStyle={{
                fontWeight: 600,
                fontSize: 14,
                color: "#BABEC6",
              }}
              tdStyle={{
                fontWeight: 500,
                fontSize: 16,
                color: "rgba(0, 0, 0, 0.7)",
                padding: 20,
              }}
            >
              Name
            </TableHeaderColumn>

            <TableHeaderColumn
              bordered={false}
              thStyle={{
                fontWeight: 600,
                fontSize: 14,
                color: "#BABEC6",
              }}
              tdStyle={{
                fontWeight: 500,
                fontSize: 16,
                color: "rgba(0, 0, 0, 0.7)",
                padding: 20,
              }}
              dataField="description"
            >
              Description
            </TableHeaderColumn>
            <TableHeaderColumn
              bordered={false}
              thStyle={{
                fontWeight: 600,
                fontSize: 18,
                color: "#BABEC6",
              }}
              tdStyle={{
                fontWeight: 500,
                fontSize: 16,
                color: "rgba(0, 0, 0, 0.7)",
                padding: 20,
              }}
              dataFormat={(cell, row) => actionFormatter(cell, row)}
            >
              Actions
            </TableHeaderColumn>
          </BootstrapTable>
        )}
      </>
      <div
        className="modal fade modal-faq modal-faq-contact"
        id="updateLocationModal"
        aria-labelledby="updateLocationModalLabel"
        aria-hidden="true"
      >
        <ModalLocation type={typeForm} datas={locationDatas} />
      </div>
    </div>
  );
};

export default Champstable;
